<template>
  <nav class="flex p-20 border-b border-gray-50">
    <div class="flex items-center gap-8">
      <button
        v-for="(item, index) in navigationItems"
        :key="index"
        type="button"
        class="flex items-center px-16 py-8 rounded-8 text-14 font-medium transition-colors duration-200"
        :class="[activeTab === item.id ? 'bg-gray-50 text-primary-1000 shadow-sm' : 'text-gray-600 hover:bg-gray-200']"
        @click="setActiveTab(item.id)"
      >
        {{ item.label }}
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'PrpSettingsNavigation',

  emits: ['set-active-tab'],

  data() {
    return {
      activeTab: 'production-offers',
      navigationItems: [
        { id: 'production-offers', label: 'Production Offers' },
        { id: 'prp-settings', label: 'Part Request Portal Settings' },
      ],
    };
  },

  methods: {
    setActiveTab(tabId) {
      this.activeTab = tabId;
      this.$emit('set-active-tab', tabId);
    },
  },
};
</script>
